import React from 'react';

interface LearnMoreCardProps {
  image?: string;
  onClick?: () => void;
}

export const LearnMoreCard: React.FC<LearnMoreCardProps> = ({
  image,
  onClick
}) => {
  return (
    <div
      className={`shadow-[0_14px_42px_0_rgba(8,15,52,0.06)] bg-white flex flex-col overflow-hidden items-stretch justify-center my-auto rounded-[10px] min-w-[270px] flex-1 shrink basis-[0%] ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="flex flex-col relative aspect-[1.55] w-full overflow-hidden items-start px-2 pt-2 pb-2">
        {image && (
          <img className="absolute h-full w-full object-cover inset-0"
            src={image}
            alt=""
          />
        )}
      </div>
    </div>
  );
};

